import { z } from 'zod'

export const noticePeriodUnitValues = [
  'calendarDays',
  'workdays',
  'weeks',
  'months',
] as const
export const NoticePeriodUnitEnum = z.enum(noticePeriodUnitValues)
export type NoticePeriodUnit = (typeof noticePeriodUnitValues)[number]

export const noticePeriodReferenceValues = [
  'endOfWeek',
  'fifteenthOfMonth',
  'fifteenthOrEndOfMonth',
  'endOfMonth',
  'endOfQuarter',
  'endOfHalfYear',
  'endOfYear',
  'noFixedEnd',
] as const
export const NoticePeriodReferenceEnum = z.enum(noticePeriodReferenceValues)
export type NoticePeriodReference = (typeof noticePeriodReferenceValues)[number]
